import { ReactElement, useState } from 'react';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { ModalWorksheetVideoVariantProps, SharedModalProps } from 'types/Modal';
import { InstantSearch } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'config/env';
import { searchClient } from 'utils/algoliaSearchClient';
import { VideoPlayerIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { CustomModal } from '../../CustomModal';
import { ModalSearchResults } from './components/ModalSearchResults';
import { ModalSearchHeader } from './components/ModalSearchHeader';
import { VideoLibrary } from './components/videoModal/VideoLibrary';
import { CustomModalContent } from '../../CustomModalContent';

type Props = SharedModalProps & ModalWorksheetVideoVariantProps;

enum VideoScreens {
  LIBRARY = 'videoLibrary',
  SEARCH = 'videoSearch',
}

export const WorksheetVideoModal = ({ handleClose, isShown, onSelect }: Props): ReactElement => {
  const [screen, setScreen] = useState(VideoScreens.LIBRARY);

  const [query, setQuery] = useState('');
  const handleSelect = (data: {
    videoUrl: string;
    title: string;
    description?: string;
    thumbnailUrl?: string;
    qrCodeUrl?: string;
  }): void => {
    if (onSelect) {
      onSelect(data);
    }
    handleClose();
  };

  return (
    <InstantSearch indexName={ALGOLIA_INDEX_NAME} searchClient={searchClient}>
      <CustomModal
        isOpen={isShown}
        placement="center"
        onClose={handleClose}
        title="Video einfügen"
        size="2xl"
        renderHeaderComponent={(props) => (
          <ModalSearchHeader
            handleClose={handleClose}
            title={props.title}
            onSearch={(value) => {
              setQuery(value);
              setScreen(VideoScreens.SEARCH);
            }}
            shouldShowBackButton={screen === VideoScreens.SEARCH}
            customBackFn={
              screen === VideoScreens.SEARCH ? () => setScreen(VideoScreens.LIBRARY) : undefined
            }
          />
        )}
        shouldAlwaysStretchHeight
      >
        <CustomModalContent
          p={{ base: '15px 20px 40px', md: '15px 20px 25px' }}
          maxHeight="100%"
          overflow="hidden"
          flex="1"
        >
          <VStack
            maxHeight="100%"
            alignItems="flex-start"
            gap="l"
            position="relative"
            minHeight="100%"
          >
            <HStack flexShrink={0}>
              <NovaIcon icon={VideoPlayerIcon} size="m" color="icon.primary" />
              <Text textStyle="h4.regular" color="text.primary">
                Videos
              </Text>
            </HStack>
            {screen === VideoScreens.LIBRARY && <VideoLibrary onSelect={handleSelect} />}
            {screen === VideoScreens.SEARCH && (
              <ModalSearchResults onSelect={handleSelect} query={query} />
            )}
          </VStack>
        </CustomModalContent>
      </CustomModal>
    </InstantSearch>
  );
};
